<template>
  <div class="inclusion-exclusion">
    <div class="info-panel">
      <div class="info-title">
        纳入条件
      </div>
      <template v-if="!edit">
        <div class="info-item" v-for="(item, index) in datasource1" :key="index">
          {{ `${item.sortNum}、${item.description}` }}
          <!-- <span class="info-item-center" v-if="item.centerName">{{ `${item.centerName}` }}</span> -->
        </div>
      </template>
      <a-table rowKey="id" v-else size="small" :columns="columns" :dataSource="datasource1" :pagination="false"
        :loading="loading">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <div class="info-panel">
      <div class="info-title">
        排除条件
      </div>
      <template v-if="!edit">
        <div class="info-item" v-for="(item, index) in datasource2" :key="index">
          {{ `${item.sortNum}、${item.description}` }}
        </div>
      </template>
      <a-table rowKey="id" v-else size="small" :columns="columns" :dataSource="datasource2" :pagination="false"
        :loading="loading">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <div class="info-panel">
      <div class="info-title">
        终止随访
      </div>
      <template v-if="!edit">
        <div class="info-item" v-for="(item, index) in datasource3" :key="index">
          {{ `${item.sortNum}、${item.description}` }}
        </div>
      </template>
      <a-table rowKey="id" v-else size="small" :columns="columns" :dataSource="datasource3" :pagination="false"
        :loading="loading">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <template v-if="isEdit">
      <a-button type="primary" v-if="!edit" @click="edit = true">编辑</a-button>
      <a-button type="primary" v-if="edit" @click="handleAdd">添加</a-button>
      <a-button v-if="edit" @click="edit = false" style="margin-left: 20px">完成</a-button>
    </template>
    <a-modal v-if="isEdit" title="编辑" rowKey="id" :width="1000" :visible="formVisible" :confirmLoading="confirmLoading"
      @ok="handleSubmit" @cancel="handleCancel">
      <a-form-model :model="model" layout="horizontal" style="padding-left: 20px;padding-right: 20px;" v-bind="{
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
      }" :rules="rules">
        <a-form-model-item label="分组名称" props="type">
          <a-radio-group v-model="model.type">
            <a-radio value="1">纳入条件</a-radio>
            <a-radio value="2">排除条件</a-radio>
            <a-radio value="3">终止随访</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="内容" props="description">
          <a-textarea :rows="2" v-model="model.description" />
        </a-form-model-item>
        <a-form-model-item label="排序" props="sortNum">
          <a-input-number v-model="model.sortNum" :min="0" :precision="0" style="width: 100%" />
        </a-form-model-item>
        <!-- <a-form-model-item label="备注弹框" props="description">
          <a-switch checkedChildren="开启" unCheckedChildren="关闭" v-model="remarkFlag" @change="onSwitchChange" />
        </a-form-model-item> -->
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { getAction, postAction, deleteAction } from '@/api/manage'
import baseRules from '@/constants/baseRules'

export default {
  name: 'CsimSchemaAttributeInclusionCriteria',
  components: {},
  props: {
    isEdit: {
      type: Boolean,
      default: true
    },
    url: {
      type: Object,
      default: () => {
        return {
          listUrl: '/scheme/filtrate/list',
          deleteUrl: '/scheme/filtrate/delete',
          saveUrl: '/scheme/filtrate/saveOrUpdate',
        }
      }
    },
  },
  data() {
    return {
      schemaModel: {},
      datasource: [],
      formVisible: false,
      confirmLoading: false,
      edit: false,
      loading: false,
      model: {},
      remarkFlag:'false',
      rules: {
        type: [baseRules.required],
        description: [baseRules.required],
        sortNum: [baseRules.required],
      },
      columns: [
        {
          title: '排序',
          align: 'center',
          width: 100,
          dataIndex: 'sortNum'
        },
        {
          title: '内容',
          align: 'left',
          ellipsis: true,
          dataIndex: 'description'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'action' },
        }
      ],
    }
  },
  computed: {
    datasource1() {
      return this.datasource.filter(item => item.type === '1')
    },
    datasource2() {
      return this.datasource.filter(item => item.type === '2')
    },
    datasource3() {
      return this.datasource.filter(item => item.type === '3')
    }
  },
  mounted() {
  },
  methods: {
    handleSetSchema(record) {
      this.schemaModel = record

      let that = this;
      this.$nextTick(()=>{
        that.loadData();
      })
    },
    loadData() {
      if (!this.schemaModel) {
        return
      }
      const schemaId = this.schemaModel.id;
      this.loading = true
      getAction(this.url.listUrl, { schemeId: schemaId }).then(res => {
        if (res.success) {
          this.datasource = res.result
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleAdd() {
      const schemaId = this.schemaModel.id;
      this.handleEdit({ schemeId: schemaId, type: '1', sortNum: 1 })
    },
    handleEdit(record) {
      if (!this.schemaModel) {
        return this.$message.error('非法参数')
      }
      this.model = Object.assign({}, record)
      this.remarkFlag= this.model.remarkFlag==='1'?true:false
      this.formVisible = true
    },
    handleDelete(id) {
      const schemaId = this.schemaModel.id;
      deleteAction(this.url.deleteUrl, { id: id, schemeId : schemaId }).then(res => {
        if (res.success) {
          this.loadData()
        }
      })
    },
    handleCancel() {
      this.model = {}
      this.formVisible = false
    },
    handleSubmit() {
      this.confirmLoading = true
      this.model.schemeId = this.schemaModel.id
      // this.model.remarkFlag = this.remarkFlag ? '1' : '0'
      postAction(this.url.saveUrl, this.model).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.loadData()
          this.handleCancel()
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    onSwitchChange() {
      this.model.remarkFlag = this.remarkFlag ? '1' : '0'
    },
  }
}
</script>

<style scoped lang="less">
.inclusion-exclusion {
  .info-panel {
    margin-bottom: 10px;

    .info-title {
      font-size: 16px;
    }

    .info-item {
      margin-left: 20px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      line-height: 28px;
    }
  }
}
</style>